import EventEmitter from 'eventemitter3';
export const EventEmitterInstance = new EventEmitter();
